import * as React from 'react';
import './styles.scss';
import { InfoPanel } from '../info-panel/info-panel';

type PasswordVerifierPanelProps = {
  title: string;
  password: string;
  username: string;
  isValid?: (isValid: boolean) => void;
}

export const PasswordVerifierPanel: React.FunctionComponent<PasswordVerifierPanelProps> = ({ title, password, username, isValid }) => {

  const splitEmail = (email: string): string[] => {
    const name = email.substring(0, email.lastIndexOf("@"));
    const words = name.split(".");
    const domain = email.substring(email.lastIndexOf("@") + 1);
    if (words && domain.length > 0) {
      words.push(domain.split(".")[0]);
    }
    return words;
  }

  const checkUsername = (email: string, password: string): boolean => {
    let result = true;
    const emailWords = splitEmail(email);
    emailWords.forEach((word: string) => {
      if (password.includes(word)) {
        result = false;
      }
    })
    return result;
  }


  const results = {
    lengthCheck: new RegExp("^.{8,}$").test(password),
    numberCheck: new RegExp("[0-9]").test(password),
    lowerCheck: new RegExp("[a-z]").test(password),
    upperCheck: new RegExp("[A-Z]").test(password),
    usernameCheck: checkUsername(username, password)
  }

  isValid && isValid(Object.values(results).every(item => item)); //check all values are true

  return (
    <InfoPanel title={title}>
      <div className={`cmp-password-verifier-row check-${results.lengthCheck}`}>At least 8 character(s)</div>
      <div className={`cmp-password-verifier-row check-${results.numberCheck}`}>At least 1 number(s)</div>
      <div className={`cmp-password-verifier-row check-${results.lowerCheck}`}>At least 1 lowercase letter(s)</div>
      <div className={`cmp-password-verifier-row check-${results.upperCheck}`}>At least 1 uppercase letter(s)</div>
      <div className={`cmp-password-verifier-row check-${results.usernameCheck}`}>Does not contain part of username</div>
    </InfoPanel>
  )
};